import { ORGANIZATIONS_NBI_LIST_PATH, ORGANIZATIONS_NBI_VIEW_PATH } from 'shared/constants/routes';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
var NbiOrganizationsList = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/NbiOrganizationsList');
});
var OrganizationView = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/OrganizationView');
});
export var Routing = function Routing() {
    return RouteGenerator({
        nbiList: {
            path: ORGANIZATIONS_NBI_LIST_PATH,
            component: NbiOrganizationsList,
            exact: true
        },
        nbiView: {
            path: ORGANIZATIONS_NBI_VIEW_PATH,
            component: OrganizationView,
            exact: true
        }
    });
};
